import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalService } from '../../../core/services/modal/modal.service';
import { ResizeService } from '../../../core/services/resize/resize.service';
import { ViewportService } from '@shared/common/services/viewport/viewport.service';
import { modalVars } from '../../../constants/modal-vars';

@Component({
  selector: 'app-reference-info',
  templateUrl: './reference-info.component.html',
  styleUrls: ['./reference-info.component.scss'],
  standalone: false
})
export class ReferenceInfoComponent implements OnInit, OnDestroy {
  isBookingHelpMessage = false;
  modalVars = modalVars;
  subscriptions: Array<Subscription> = [];

  @Input() text: string;
  @Input() additionalClass: string;
  @Input() modalId = 'help-booking-info';

  constructor(
    public modalService: ModalService,
    private readonly viewportService: ViewportService,
    private readonly resizeService: ResizeService
  ) {}

  get isMobile() {
    return this.viewportService.isMobileDevice();
  }

  ngOnInit() {
    this.subscriptions.push(
      this.resizeService.resize().subscribe(() => {
        if (this.isMobile) {
          this.modalService.close(this.modalId);
        }
        this.isBookingHelpMessage = false;
      })
    );
  }

  openBookingHelpMessage() {
    if (this.isMobile) {
      this.modalService.open(this.modalId);
    }
  }
  toggleBookingHelpMessage() {
    if (!this.isMobile) {
      this.isBookingHelpMessage = !this.isBookingHelpMessage;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }
}
